import { render, staticRenderFns } from "./registration-by-phone.vue?vue&type=template&id=5f85e1ec"
import script from "./registration-by-phone.vue?vue&type=script&lang=js"
export * from "./registration-by-phone.vue?vue&type=script&lang=js"
import style0 from "./registration-by-phone.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/quick-login-reg/registration-by-phone.vue
// module id = c/8O
// module chunks = 0